module.exports = __webpack_public_path__ + "static/media/pic3.d259b5da.jpg";